import styled from "@emotion/styled";
import React from "react";
import { Button } from "../Button";
import { Typography } from "../Typography";
import { useIsDesktopUp, useIsTabletUp } from "../utils/use-media-breakpoints";

const PrivateProfileWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100vw;
  max-width: 100vw;
  overflow: hidden;
  position: relative;

  background: rgb(244, 242, 240);
  background: linear-gradient(
    0deg,
    rgba(244, 242, 240, 1) 12%,
    rgba(19, 171, 219, 1) 100%
  );
`;

const PrivateProfileContent = styled.div`
  text-align: center;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  width: 100vw;
  overflow: hidden;
`;

const TextWrapper = styled.div`
  p {
    margin: 32px 0 24px 0;
  }

  padding: 24px;
  @media ${(props) => props.theme.bp.tabletUp} {
    padding: 0;
  }

  margin: 156px auto 200px;

  @media ${(props) => props.theme.bp.tabletUp} {
    margin: 156px auto 0;
  }
`;

const Title = styled(Typography)`
  font-size: 48px !important;
  margin-bottom: 14px;
  line-height: 48px !important;
`;

const Mountains = styled.img`
  position: absolute;
  bottom: -4px;
  width: 100%;
  height: auto;
`;

const Left = styled.img`
  height: 90vh;
  width: auto;
  margin-top: auto;
  flex-shrink: 0;
`;

const Right = styled.img`
  height: 100vh;
  width: auto;
  flex-shrink: 0;
`;

const RightSmall = styled.img`
  height: 65vh;
  width: auto;
  position: absolute;
  bottom: 0;
  right: 0;
`;

const Clouds = styled.img`
  position: absolute;
  top: 10%;
  left: 0;
  right: 0;
  margin: auto;
`;

export const PrivateProfilePage = () => {
  const isDesktopUp = useIsDesktopUp();
  const isTabletUp = useIsTabletUp();

  return (
    <PrivateProfileWrapper>
      {isDesktopUp && <Clouds src="/images/app/private-profile/clouds.svg" />}
      <Mountains src="/images/app/private-profile/mountains.svg" />

      <PrivateProfileContent>
        {isTabletUp && <Left src="/images/app/private-profile/left.svg" />}

        <TextWrapper>
          <Title use="dashboardTitle2" as="h2">
            This profile is private
          </Title>
          <Typography use="subtitle2" as="p">
            This profile owner has chosen to keep their profile private.
            <br />
            Did you want to start your climate impact journey with us?
          </Typography>
          <Button href="/plan" primary text="Join us today"></Button>
        </TextWrapper>

        {isTabletUp ? (
          <Right src="/images/app/private-profile/right.svg" />
        ) : (
          <RightSmall src="/images/app/private-profile/right-small.svg" />
        )}
      </PrivateProfileContent>
    </PrivateProfileWrapper>
  );
};
